import React from "react";

export default function ConfirmModal({
  isOpen,
  message,
  note,
  onConfirm,
  onClose,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="
        fixed inset-0 z-50
        flex items-center justify-center
        bg-black/50
      "
      onClick={onClose}
    >
      {/* Modal box */}
      <div
        className="
          bg-white
          w-full max-w-md
          rounded-xl
          shadow-2xl
          p-6
        "
        onClick={(e) => e.stopPropagation()}
      >
        {/* Message */}
        <div className="border rounded-lg p-4 text-center text-gray-700 mb-8">
          {message}
        </div>
        <div className="p-4 text-center text-gray-700 mb-8">
          {note}
        </div>

        {/* Actions */}
        <div className="flex justify-center gap-4">
          <button
            onClick={onConfirm}
            className="
              px-6 py-2
              rounded-md
              bg-slate-800
              text-yellow-400
              font-medium
              hover:bg-slate-900
              transition
            "
          >
            تأیید
          </button>

          <button
            onClick={onClose}
            className="
              px-6 py-2
              rounded-md
              border
              text-slate-700
              hover:bg-slate-100
              transition
            "
          >
            انصراف
          </button>
        </div>
      </div>
    </div>
  );
}
